import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { FaFileExcel } from "react-icons/fa";
import { getUiInterface } from "../../locales/translationUtils";

interface ExportExcelButtonProps {
  onClick: () => void;
  exportando: boolean;
  /** Sobrepõe o variant padrão ("outline-success"), para telas que já têm uma paleta própria de botões. */
  variant?: string;
}

/**
 * Botão de exportar para Excel, reaproveitado em todas as telas com grid.
 *
 * Só desenha o botão - a busca de todos os itens que batem com o filtro (sem
 * paginação) e a montagem das linhas continuam em cada tela, porque cada uma
 * tem seu próprio serviço e suas próprias colunas.
 */
const ExportExcelButton: React.FC<ExportExcelButtonProps> = ({ onClick, exportando, variant = "outline-success" }) => (
  <Button variant={variant} onClick={onClick} disabled={exportando} title={getUiInterface('exportExcel')}>
    {exportando ? <Spinner as="span" size="sm" animation="border" /> : <FaFileExcel />}
  </Button>
);

export default ExportExcelButton;
